import { axiosInstance } from "lib/axios";
import { citationAPI, searchAPI } from "services/apis.service";
import axios from "axios";
import Hashes from "jshashes";

const MD5 = Hashes.MD5();

// Converts any accessDate value (Date object, dayjs, or ISO string) to clean YYYY-MM-DD
const cleanAccessDate = (val) => {
  if (!val) return val;
  // dayjs object (has .format method)
  if (typeof val === "object" && typeof val.format === "function") {
    return val.format("YYYY-MM-DD");
  }
  // JS Date object
  if (val instanceof Date && !isNaN(val.getTime())) {
    const y = val.getFullYear();
    const m = String(val.getMonth() + 1).padStart(2, "0");
    const d = String(val.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  // String — strip anything after T
  if (typeof val === "string") {
    return val.split("T")[0];
  }
  return val;
};


export const fetchCitationStyles = async () => {
  const { data } = await axiosInstance.get(citationAPI.getCitationStyles);
  return data;
};

export const fetchCitationFields = async (user, currentItemType, selectedStyle = "apa") => {
  const { data } = await axiosInstance.post(
    searchAPI.GetCitationDynamicData,
    {
      user: user.userId,
      itemTypeId: currentItemType.id,
      style: selectedStyle,
    }
  );

  return data;
};



console.log(cleanAccessDate("2026-03-24T18:30:00Z"));
export const fetchCitationMetaData = async (signal, url) => {
  const { data } = await axiosInstance.post(
    citationAPI.getCitationMeta,
    url,
    {
      headers: {
        "Content-Type": "text/plain",
      },
      signal,
    }
  );
  return data;
};

export const fetchSavedCitationMeta = async (collectionSourceId, user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getCitation,
    {
      collectionSourceId: collectionSourceId,
      userId: user.userId,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const generateCitation = async (
  currentItemType,
  selectedStyle,
  articleData,
  authors
) => {
  const { day, month, ...restArticleData } = articleData;
  // If the date string doesn't include a year or isn't ND/n.d., we treat it as no-date
  const hasYear = (articleData.date || "").match(/\d{4}|ND|n\.d\./i);
  let filteredArticleData = hasYear
    ? { ...articleData }
    : { ...restArticleData, date: "" };

  filteredArticleData.accessDate = cleanAccessDate(filteredArticleData.accessDate);

  const { data } = await axiosInstance.post(
    `${citationAPI.getCitation}?responseformat=html&style=${selectedStyle}`,
    {
      items: [
        {
          ...filteredArticleData,
          itemType:
            currentItemType.toLowerCase() === "webpage"
              ? "webpage"
              : currentItemType,
          styles: selectedStyle,
          key: articleData.key ? articleData.key : "VH$KV",

          ...(authors.length > 0 &&
            authors[0].firstName.length > 0 ? {
            creators: authors,
          } : {
            creators: []
          }),
        },
      ],
    },
    {
      cache: false,
    }
  );
  return data;
};

export const generateRISCitation = async (
  currentItemType,
  articleData,
  authors
) => {
  // Remove 'styles' field — not accepted by the RIS endpoint
  const { styles, ...cleanArticleData } = articleData;
  const { day, month, ...restCleanData } = cleanArticleData;
  // If the date string doesn't include a year or isn't ND/n.d., we treat it as no-date
  const hasYear = (cleanArticleData.date || "").match(/\d{4}|ND|n\.d\./i);
  let finalArticleData = hasYear
    ? { ...cleanArticleData }
    : { ...restCleanData, date: "" };

  finalArticleData.accessDate = cleanAccessDate(finalArticleData.accessDate);

  const { data } = await axiosInstance.post(
    `${citationAPI.getCitation}?responseformat=ris`,
    {
      items: [
        {
          ...finalArticleData,
          itemType:
            currentItemType.toLowerCase() === "webpage"
              ? "webpage"
              : currentItemType,
          key: cleanArticleData.key ? cleanArticleData.key : "VH$KV",

          ...(authors.length > 0 &&
            authors[0].firstName.length > 0 ? {
            creators: authors,
          } : {
            creators: []
          }),
        },
      ],
    },
    {
      cache: false,
    }
  );
  return data;
};
